<p-toast />
<p-confirmpopup />
<p-confirmdialog key="global" />
@if (chromeVisible()) {
  <nav class="navbar navbar-fixed-top tw:flex tw:relative tw:flex-wrap tw:items-center tw:justify-between tw:px-4">
    <div class="navbar-inner-holder">
      <a class="navbar-brand">
        <img
          alt=""
          src="/assets/images/elements/site-logo.svg"
        />
      </a>
    </div>
    <div
      class="tw:flex tw:flex-row tw:flex-nowrap"
      id="main-nav"
    >
      <div class="tw:flex tw:gap-2 tw:items-center tw:justify-center">
        <prime-button
          (onClick)="searchModalOpen()"
          [link]="true"
          [text]="true"
          ariaLabel="Search"
          size="small"
        >
          <ng-template #iconTemplate>
            <pinnakl-icon
              class="tw:text-bluegray-600 tw:flex tw:h-5 tw:w-5"
              name="search"
            />
          </ng-template>
        </prime-button>
        <a
          aria-label="User settings"
          routerLink="/user-settings"
        >
          <pinnakl-icon
            class="tw:text-bluegray-600 tw:flex tw:h-5 tw:w-5 tw:cursor-pointer"
            name="cog"
          />
        </a>
        <header-user-profile
          [userName]="currentUser()?.fullName ?? ''"
          (logout)="logout()"
        ></header-user-profile>
      </div>
    </div>
  </nav>
  <aside
    [class.aside-opened]="menuOpen()"
    class="aside-menu-holder tw:text-[0.875rem]"
    id="main-aside"
  >
    <a
      (click)="toggleMenu()"
      class="aside-menu-holder-trigger aside-item tw:cursor-pointer"
    >
      <i class="icon-pinnakl-menu"></i>
    </a>
    <ul class="aside-menu-list">
      <li routerLinkActive="active">
        <a
          class="tooltip"
          routerLink="/dashboard"
          title=""
        >
          <i
            class="icon-pinnakl-side-dashboard-active"
            title="Dashboard"
          ></i>
          <span>Dashboard</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a
          class="tooltip"
          routerLink="/oms"
          title=""
        >
          <i
            class="icon-pinnakl-side-oms"
            title="OMS"
          ></i>
          <span>OMS</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a
          class="tooltip"
          routerLink="/ems"
          title=""
        >
          <i
            class="icon-pinnakl-globe"
            title="EMS"
          ></i>
          <span>EMS</span>
        </a>
      </li>
      @if (emsV3Visible() || emsV3FlagOn()) {
        <li routerLinkActive="active">
          <a
            class="tooltip tw:text-p-blue-500"
            routerLink="/ems-v3"
            title=""
          >
            <i
              class="icon-pinnakl-globe"
              title="EMS V3"
            ></i>
            <span>EMS V3</span>
          </a>
        </li>
      }
      @if (!isPmsAccessLevelFour()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/pms"
            title=""
          >
            <i
              class="icon-pinnakl-side-positions-active"
              title="PMS"
            ></i>
            <span>PMS</span>
          </a>
        </li>
      }
      <li routerLinkActive="active">
        <a
          class="tooltip"
          routerLink="/pricing"
          title=""
        >
          <i
            class="icon-pinnakl-side-pricing-active"
            title="Pricing"
          ></i>
          <span>Pricing</span>
        </a>
      </li>
      @if (!isPmsAccessLevelFour()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/risk/risk-home"
            title=""
          >
            <i
              class="icon-pinnakl-side-risk-active"
              title="Risk"
            ></i>
            <span>Risk</span>
          </a>
        </li>
      }
      <li routerLinkActive="active">
        <a
          class="tooltip"
          routerLink="/reconciliation"
          title=""
        >
          <i
            class="icon-pinnakl-side-reconciliation-active-svg"
            title="Recon"
          ></i>
          <span>Reconciliation</span>
        </a>
      </li>
      @if (!isPmsAccessLevelFour()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/attribution"
            title="Attribution"
          >
            <i
              class="icon-pinnakl-side-pl-active"
              title="Attribution"
            ></i>
            <span>Attribution</span>
          </a>
        </li>
      }
      <li [class.active]="reportingActive()">
        <a
          class="tooltip"
          routerLink="/reporting/all-reports"
          title=""
        >
          <i
            class="icon-pinnakl-side-reports-active"
            title="Reports"
          ></i>
          <span>Reports</span>
        </a>
      </li>
      @if (showIncompleteScreens() || shadowNavFlagOn()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/shadow-nav/shadow-nav-home"
            title=""
          >
            <i
              class="icon-pinnakl-shadow-nav-active"
              title="Shadow NAV"
            ></i>
            <span>Shadow NAV</span>
          </a>
        </li>
      }
      <li routerLinkActive="active">
        <a
          class="tooltip"
          routerLink="/securities"
          title=""
        >
          <i
            class="icon-pinnakl-side-securities-active"
            title="Securities"
          ></i>
          <span>Securities</span>
        </a>
      </li>
      @if (includeTesting) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/testing"
            title=""
          >
            <i
              class="icon-pinnakl-side-securities-active"
              title="Testing"
            ></i>
            <span>Testing</span>
          </a>
        </li>
      }

      <li routerLinkActive="active">
        <a
          class="tooltip tw:flex! tw:items-center"
          routerLink="/bulk-data-upload"
          title="Bulk Data Upload"
        >
          <pinnakl-icon
            class="tw:flex tw:h-5 tw:w-5 tw:shrink-0 tw:ml-0.5"
            name="file"
            title="bulk data upload"
          />
          <span class="tw:min-w-0">Bulk Data Upload</span>
        </a>
      </li>
      @if (!isPmsAccessLevelFour()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/rebalancing"
            title=""
          >
            <i
              class="icon-pinnakl-rebalance"
              title="Modeling"
            ></i>
            <span>Rebalancing</span>
          </a>
        </li>
      }

      @if (!isPmsAccessLevelFour()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/stock-loan"
            title=""
          >
            <i
              class="custom-icon-stock-loan position-icon"
              title="Stock Loan"
            ></i>
            <span>Stock Loan</span>
          </a>
        </li>
      }
      @if (!isPmsAccessLevelFour()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/corporate-actions"
            title=""
          >
            <i
              class="custom-icon-corporate-action position-icon"
              title="Corporate Actions"
            ></i>
            <span>Corporate Actions</span>
          </a>
        </li>
      }
      <li routerLinkActive="active">
        <a
          class="tooltip tw:flex! tw:items-center"
          routerLink="/configuration"
          title="Configuration"
        >
          <pinnakl-icon
            class="tw:flex tw:h-5 tw:w-5 tw:shrink-0 tw:ml-0.5"
            name="cog"
          />
          <span class="tw:min-w-0">Configuration</span>
        </a>
      </li>
      @if (isLocal || apiPlaygroundFlagOn()) {
        <li routerLinkActive="active">
          <a
            class="tooltip"
            routerLink="/api-playground"
            title=""
          >
            <i class="icon-pinnakl-fire"></i>
            <span>API Playground</span>
          </a>
        </li>
      }
    </ul>
  </aside>
}
<main
  [class.aside-opened]="menuOpen()"
  class="main-holder tw:flex tw:min-h-[calc(100vh-58px)] tw:flex-col tw:overflow-hidden tw:bg-surface-100 tw:text-[0.875rem]"
>
  <pinnakl-spinner
    [branded]="initialNavigationPending() || !chromeVisible()"
    [forceVisible]="initialNavigationPending()"
  />
  <reconnect-window></reconnect-window>
  <default-confirm-action></default-confirm-action>
  <auth-recovery-panel />
  @if (userIsAvailable()) {
    <router-outlet></router-outlet>
  }
</main>
<div
  class="atdl-content"
  id="reactDropdown"
></div>
